import { render, staticRenderFns } from "./ChatSystemBox.vue?vue&type=template&id=78dfd5da&scoped=true"
import script from "./ChatSystemBox.vue?vue&type=script&lang=js"
export * from "./ChatSystemBox.vue?vue&type=script&lang=js"
import style0 from "./ChatSystemBox.vue?vue&type=style&index=0&id=78dfd5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_13f162de80bf2e87404863986ae68eb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dfd5da",
  null
  
)

export default component.exports